var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMinusBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 2,
    viewBox: "0 0 19 2",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector 3 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9446 0.999782C18.9446 1.4907 18.5466 1.88867 18.0557 1.88867L0.944553 1.88867C0.453633 1.88867 0.055664 1.4907 0.055664 0.999783C0.055664 0.508862 0.453632 0.110894 0.944552 0.110894L18.0557 0.110893C18.5466 0.110893 18.9446 0.508862 18.9446 0.999782Z",
    fill: "#1E293B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMinusBlack);
export default __webpack_public_path__ + "static/media/ic_minus_black.5cc064c116d26e3a1fd9da373f5a503e.svg";
export { ForwardRef as ReactComponent };